import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab, Button, Switch, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomerList from "../../features/manageCustomers/customerList";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import {
  useLazyCustomerExportQuery,
  useLazyDeleteCustomerQuery,
  useLazyGetCustomersQuery,
  useUpdateStatusCustomerMutation,
} from "../../services/customer";
import { Category, Customer } from "../../types/General";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import { showError, showToast } from "../../constants/toasts";
import { isValidInput } from "../../utils/validations";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { ROLES } from "../../utils/enums";
import usePermission from "../../hooks/usePermission";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomers = () => {
  const navigate = useNavigate();

  const [getCustomers] = useLazyGetCustomersQuery();

  const [updateStatus] = useUpdateStatusCustomerMutation();
  const [deleteCustomer] = useLazyDeleteCustomerQuery();
  const [exportCsv] = useLazyCustomerExportQuery();
  const { isAdd, isDelete } = usePermission({
    label: "Manage Customers",
    page_permission: "isView",
  });
  const [valueTabs, setValueTabs] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [rows, setRows] = useState<Customer[]>([]);
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      isBlocked: status,
      userId: id,
    };

    try {
      const response = await updateStatus(body).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = rows?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              isBlocked: status,
            };
          }
          return item;
        });
        setRows(updatedData);
        if (status === true) {
          showToast("Customer deactivated successfully");
        } else {
          showToast("Customer activated successfully");
        }
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 260,
      field: "fullName",
      headerName: "Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate(`/manage-customers/detail/${row?._id}`)}
          >
            <figure>
              <img
                src={row?.image || "/static/images/user_placeholder.png"}
                alt=""
              />
            </figure>
            <p>
              <b>{row?.fullName || "-"}</b> <span>{row?.email || "-"}</span>{" "}
              <span>{row?.countryCode + row?.phone || "-"}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "address",
      headerName: "Address",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div>
            <p>
              {row?.address || "-"},{row?.country || ""}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "propertiesCount",
      headerName: "Total Properties",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <div>
            <p>{row?.propertiesCount || "0"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 130,
      field: "issuesCount",
      headerName: "Total Issues",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <div>
            <p>{row?.issuesCount || "0"}</p>
          </div>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "document",
    //   headerName: "Document",
    //   editable: false,
    //   sortable: false,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: () => {
    //     return (
    //       <Button className="btn sm btn_primary" onClick={() => setOpen(true)}>
    //         View
    //       </Button>
    //     );
    //   },
    // },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <Switch
          {...label}
          size="small"
          checked={!row?.isBlocked}
          onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
        />
      ),
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-customers/detail/${row?._id}`)}
              >
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-customers/edit/${row?._id}`)}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>

            {isDelete ? (
              <Box>
                <IconButton
                  onClick={() => {
                    setSelectedId(row?._id);
                    setOpenDelete(true);
                  }}
                >
                  <img src="/static/images/trash2_icon.svg" alt="" />
                </IconButton>
              </Box>
            ) : null}

            {/* <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box> */}
          </div>
        );
      },
    },
  ];

  const getExportCsv = async () => {
    try {
      const response = await exportCsv({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        role: ROLES.USER,
        status: valueTabs + 1,
      }).unwrap();
      if (response?.statusCode === 200) {
        window.open(response?.data || "");
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getAllCustomers = async () => {
    setIsLoading(true);
    try {
      const response = await getCustomers({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        role: ROLES.USER,
        status: valueTabs + 1,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    setIsLoading(true);
    const body = {
      userId: selectedId || "",
    };
    try {
      const response = await deleteCustomer(body).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast("Customer Deleted successfully");
        getAllCustomers();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllCustomers();
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Customers</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Customers
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Approved Customers" {...a11yProps(0)} />
              <Tab label="Pending Customers" {...a11yProps(1)} />
              <Tab label="Rejected Customers" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        {/* <CustomerTopbar /> */}
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            {isAdd ? (
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-customers/add")}
              >
                <AddIcon /> Add
              </Button>
            ) : null}
            {rows.length !==0 &&<Button className="btn btn_grey" onClick={getExportCsv}>
              <DownloadIcon /> Export
            </Button>}
          </div>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={isLoading}
            />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={isLoading}
            />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={isLoading}
            />
          </div>
        </CustomTabPanel>
      </div>
      <ConfirmationModal
        text="Are you sure to delete this customer"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </MainContainer>
  );
};

export default ManageCustomers;
